import { useUserProfileSelector } from "@redux/reducers/deal";

export const useResolvedRegistrationCountry = () => {
  const profile = useUserProfileSelector() || {};
  return (
    profile.registrationCountry ||
    profile.deliveryCountry ||
    profile.billingCountry ||
    null
  );
};
